import { render } from "./Tree.vue?vue&type=template&id=2641b7bc&scoped=true"
import script from "./Tree.vue?vue&type=script&lang=js"
export * from "./Tree.vue?vue&type=script&lang=js"

import "./Tree.vue?vue&type=style&index=0&id=2641b7bc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2641b7bc"]])

export default __exports__